import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ino_lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("ino_lang", lang);
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang] || translations.en;
    let fb = translations.en;
    for (const p of parts) {
      cur = cur == null ? undefined : cur[p];
      fb = fb == null ? undefined : fb[p];
    }
    return cur ?? fb ?? path;
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
